module.exports = __webpack_public_path__ + "static/media/unattended1.14eb38d4.png";